import "../scss/global.scss";
import "./scripts.js";
